import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showHideFilterModalReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import {
  fetchRevenueList,
  fetchSettlementList,
  getAllSettlementCount,
} from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import { primaryColor } from "../../../../utility/constants/colorManager";
import {
  SS_AUTH_TOKEN,
  SS_ROLE,
} from "../../../../utility/constants/secureStorageManager";
import {
  ADMIN,
  ADMIN_USER,
  FINANCE_REVENUE_ACL,
  FINANCE_SETTLEMENT_ACL,
  RUPEES_SYMBOL,
  SETTLEMENT_DOWNLOAD_ACL,
  FINANCE_REVENUE_DOWNLOAD_ACL,
  STATUS_CODE_200,
  BULK_SETTLEMENT_UPLOAD,
  SETTLEMENT_APPROVE_ACL,
} from "../../../../utility/constants/valueConstants";
import { setTabsAccToAcl } from "../../../../utility/convertors";
import { formatBalance } from "../../../../utility/moneyFormatter";
import {
  RevenueListHeaders,
  SettlementListHeaders,
} from "../../../../utility/TableHeaders";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import CustomTabs from "../../../components/main_comps/custom_tabs";
import MainComponent from "../../../components/ui_comps/MainComponent";
import DownloadSettlementModal from "./DownloadSettlement";
import DownloadRevenueModal from "./DownloadRevenue";
import UploadBtn from "../../../components/ui_comps/customUploadBtn";
import CustomUploadField2 from "../../../components/ui_comps/CustomUploadField2";
import { Upwardarrow } from "../../../../utility/constants/assetsManager";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { useSnackbar } from "notistack";
import { editSettlementList } from "../../../../data/redux/slice/listingDataSlice";
import { API_ENDPOINT } from "../../../../data/network/services/ApiEndpoint";
import { formDataPush } from "../clients/client_onboard/ResellerDetails";
import { useNavigate } from "react-router";
import { FiInfo } from "react-icons/fi";
import { excelDateToJSDate } from "../../../../utility/dateConverter";
import { fullScreenLoadingSlice } from "../../../../data/redux/slice/loaderSlice";

const FilterComponent = ({ onPress, currentTab, aclData, onUpload }) => {
  return (
    <div style={{ display: "flex" }}>
      {aclData?.includes(BULK_SETTLEMENT_UPLOAD) && currentTab === 0 && (
        <>
          <div style={{ marginRight: "20px" }}>
            <CustomButton
              title="Upload settlement Report"
              backgroundColor="#38369C"
              onClick={onUpload}
            />
          </div>
        </>
      )}
      <div>
        {aclData.includes(SETTLEMENT_DOWNLOAD_ACL) && currentTab === 0 ? (
          <CustomButton
            title="Download Report"
            backgroundColor="#38369C"
            onClick={onPress}
          />
        ) : aclData.includes(FINANCE_REVENUE_DOWNLOAD_ACL) &&
          currentTab === 1 ? (
          <CustomButton
            title="Download Report"
            backgroundColor="#38369C"
            onClick={onPress}
          />
        ) : null}
      </div>
    </div>
  );
};

const CountComponent = ({ data, unsettledAmount }) => {
  return (
    <div style={{ display: "flex" }}>
      <div
        style={{
          borderRadius: "4px",
          padding: "10px 10px",
          fontSize: 14,
          fontWeight: "500",
          color: "#6C6B6B",
          marginRight: "20px",
          border: "1px solid #DFDFDF",
        }}
      >
        <p style={{ color: primaryColor }}>
          Settled Amount:{" "}
          {RUPEES_SYMBOL +
            " " +
            formatBalance(Number(data?.totalSettledAmount ?? 0))}
        </p>
      </div>

      {/* <div
        style={{
          borderRadius: "4px",
          padding: "10px 10px",
          fontSize: 14,
          fontWeight: "500",
          color: "#6C6B6B",
          marginRight: "20px",
          border: "1px solid #DFDFDF",
        }}
      >
        <p style={{ color: primaryColor }}>
          Unsettled Amount:{" "}
          {RUPEES_SYMBOL +
            " " +
            formatBalance(Number(unsettledAmount?.totalPayin ?? 0))}
        </p>
      </div> */}
    </div>
  );
};

const tabs = [
  { name: "Settlement", key: 0, aclValue: FINANCE_SETTLEMENT_ACL },
  { name: "Revenue", key: 1, aclValue: FINANCE_REVENUE_ACL },
  { name: "Van settlement", key: 2, aclValue: "" },
];

function SettlementIndex() {
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState(0);
  const [reportModal, setReportModal] = useState(false);
  const [uploadReport, setUploadReport] = useState(false);
  const [uploadFile, setUploadFile] = useState();
  const [failedEntry, setFailedEntry] = useState([]);
  const [openFailedModal, setOpenFailedModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const settlementList = useSelector(
    (state) => state.listingSlice.settlementList
  );
  const transactionVolumeData = useSelector(
    (state) => state.dashboardCountSlice.transactionVolume
  );
  const filters = useSelector((state) => state.globalFiltersSlice);
  const revenueList = useSelector((state) => state.listingSlice.revenueList);
  const settlementCount = useSelector(
    (state) => state.dashboardCountSlice.settlementCount
  );

  const navigate = useNavigate();

  console.log(settlementList, "settlement list");

  const aclData = useSelector((state) => state.aclSlice.aclList);

  useEffect(() => {
    dispatch(getAllSettlementCount({}));
  }, []);

  useEffect(() => {
    if (aclData.includes(FINANCE_SETTLEMENT_ACL)) {
      setCurrentTab(0);
    } else {
      setCurrentTab(1);
    }
  }, []);

  const handleFile = (event) => {
    console.log(event, "Event");
    setUploadFile(event.target.files[0]);
    console.log(uploadFile, "uploadFile");
  };

  useEffect(() => {
    console.log(failedEntry, "Failedentries");
  }, [failedEntry]);

  useEffect(() => {
    if (aclData.includes(FINANCE_SETTLEMENT_ACL)) {
      dispatch(
        fetchSettlementList({
          page: 0,
          size: 10,
          dateRange:
            filters?.fromDate && filters?.toDate
              ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                "-" +
                moment(filters?.toDate).format("DD/MM/YYYY")
              : "",
          userId: filters?.clientId?.value ?? "",
          userRefId: filters?.resellerId?.value ?? "",
          serviceType: filters?.serviceType?.value ?? "",
          status: filters?.status?.value ?? "",
        })
      );
    } else {
      dispatch(
        fetchRevenueList({
          page: 0,
          size: 10,
          dateRange:
            filters?.fromDate && filters?.toDate
              ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                "-" +
                moment(filters?.toDate).format("DD/MM/YYYY")
              : "",
          userId: filters?.clientId?.value ?? "",
          userRefId: filters?.resellerId?.value ?? "",
          serviceType: filters?.serviceType?.value ?? "",
          status: filters?.status?.value ?? "",
        })
      );
    }
  }, [currentTab]);

  useEffect(() => {
    console.log(uploadFile, "Upload file");
  }, [uploadFile]);

  const onClickUploadFileInt = () => {
    if (!uploadFile) {
      return;
    }
    dispatch(fullScreenLoadingSlice(true));
    if (uploadFile) {
      enqueueSnackbar("Settlement record Initiated", {
        variant: "success",
      });
    }
    const excelData = formDataPush({
      file: uploadFile,
    });
    let token = secureStorage.getItem(SS_AUTH_TOKEN);
    fetch(API_ENDPOINT.core_url + "finance/upload/settlement/details", {
      body: excelData,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        dispatch(fullScreenLoadingSlice(false));
        res.json().then((res) => {
          console.log(res, "Response");
          if (res.statusCode === STATUS_CODE_200) {
            setFailedEntry(res?.data);
            setUploadReport(false);
            setOpenFailedModal(true);
            enqueueSnackbar(res.message, {
              variant: "success",
            });
          } else {
            setUploadReport(false);
          }
        });
      })
      .catch((err) => {
        console.log(err, "Error");
      })
      .finally(() => {});
  };
  useEffect(() => {
    if (uploadFile) {
      onClickUploadFileInt();
    }
  }, [uploadFile]);

  const fileDownloadSample = () => {
    const sampleFilepath = "/Template.xlsx";
    const link = document.createElement("a");
    link.href = sampleFilepath;
    link.download = "Template.xlsx";
    link.click();
  };

  const changeSettlementStatus = (action, settlementId) => {
    ApiRequestPost.changeSettlementStatus({
      action,
      settlementId,
    })
      .then((res) => {
        refreshPage();
        console.log(res, "Response");
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {});
  };

  const setHeaders = (data) => {
    if (!aclData?.includes(SETTLEMENT_APPROVE_ACL)) {
      return data.filter((e) => e.title !== "Action");
    } else {
      return data;
    }
  };

  const refreshPage = () => {
    dispatch(
      fetchSettlementList({
        page: 0,
        size: 10,
        dateRange:
          filters?.fromDate && filters?.toDate
            ? moment(filters?.fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(filters?.toDate).format("DD/MM/YYYY")
            : "",
        userId: filters?.clientId?.value ?? "",
        userRefId: filters?.resellerId?.value ?? "",
        serviceType: filters?.serviceType?.value ?? "",
        status: filters?.status?.value ?? "",
      })
    );
  };

  useEffect(() => {
    console.log(failedEntry, "Failed entry");
  }, [failedEntry]);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: [
                "dateRange",
                "clientName",
                "resellerName",
                "serviceType",
                "settlementStatus",
              ],
            })
          );
        }}
        headerTitle="Settlement"
        onClickFilterCall={(data) => {
          if (currentTab === 0) {
            dispatch(
              fetchSettlementList({
                page: 0,
                size: 10,
                dateRange:
                  data?.fromDate && data?.toDate
                    ? moment(data?.fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(data?.toDate).format("DD/MM/YYYY")
                    : "",
                userId: data?.clientId?.value ?? "",
                userRefId: data?.resellerId?.value ?? "",
                serviceType: data?.serviceType?.value ?? "",
                status: data?.status?.value ?? "",
              })
            );
          } else
            dispatch(
              fetchRevenueList({
                page: 0,
                size: 10,
                dateRange:
                  data?.fromDate && data?.toDate
                    ? moment(data?.fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(data?.toDate).format("DD/MM/YYYY")
                    : "",
                userId: data?.clientId?.value ?? "",
                userRefId: data?.resellerId?.value ?? "",
                serviceType: data?.serviceType?.value ?? "",
                status: data?.status?.value ?? "",
              })
            );
        }}
      />

      <CustomTabs
        tabs={setTabsAccToAcl(tabs, aclData)}
        activeIndex={currentTab}
        passCurrentTab={(data) => {
          setCurrentTab(data);
          if (data === 0) {
            dispatch(
              fetchSettlementList({
                page: 0,
                size: 10,
                dateRange:
                  filters?.fromDate && filters?.toDate
                    ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(filters?.toDate).format("DD/MM/YYYY")
                    : "",
                userId: filters?.clientId?.value ?? "",
                userRefId: filters?.resellerId?.value ?? "",
                serviceType: filters?.serviceType?.value ?? "",
                status: filters?.status?.value ?? "",
              })
            );
          } else {
            dispatch(
              fetchRevenueList({
                page: 0,
                size: 10,
                dateRange:
                  filters?.fromDate && filters?.toDate
                    ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(filters?.toDate).format("DD/MM/YYYY")
                    : "",
                userId: filters?.clientId?.value ?? "",
                userRefId: filters?.resellerId?.value ?? "",
                serviceType: filters?.serviceType?.value ?? "",
                status: filters?.status?.value ?? "",
              })
            );
          }
        }}
        actionComponent={
          <FilterComponent
            onPress={() => {
              setReportModal(true);
            }}
            onUpload={() => {
              setUploadReport(true);
            }}
            aclData={aclData}
            currentTab={currentTab}
          />
        }
        countComponent={
          <CountComponent
            data={settlementCount}
            unsettledAmount={transactionVolumeData}
          />
        }
      />

      <div style={{ padding: "0px 10px", overflow: "hidden" }}>
        <CustomTable
          currentPage={
            currentTab === 0
              ? settlementList?.currentPageNo - 1
              : revenueList.currentPageNo - 1
          }
          data={
            currentTab === 0 ? settlementList.settlements : revenueList.revenues
          }
          headers={
            currentTab === 0
              ? setHeaders(SettlementListHeaders)
              : RevenueListHeaders
          }
          totalElements={
            currentTab === 0
              ? settlementList.totalRecords
              : revenueList.totalRecords
          }
          totalPages={
            currentTab === 0
              ? settlementList.totalPages
              : revenueList.totalPages
          }
          handlePaginate={(page) => {
            // setCurrentPage(page);
            if (currentTab === 0) {
              dispatch(
                fetchSettlementList({
                  page: page + 1,
                  size: 10,
                  dateRange:
                    filters?.fromDate && filters?.toDate
                      ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                        "-" +
                        moment(filters?.toDate).format("DD/MM/YYYY")
                      : "",
                  userId: filters?.clientId?.value ?? "",
                  userRefId: filters?.resellerId?.value ?? "",
                  serviceType: filters?.serviceType?.value ?? "",
                  status: filters?.status?.value ?? "",
                })
              );
            } else
              dispatch(
                fetchRevenueList({
                  page: page + 1,
                  size: 10,
                  dateRange:
                    filters?.fromDate && filters?.toDate
                      ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                        "-" +
                        moment(filters?.toDate).format("DD/MM/YYYY")
                      : "",
                  userId: filters?.clientId?.value ?? "",
                  userRefId: filters?.resellerId?.value ?? "",
                  serviceType: filters?.serviceType?.value ?? "",
                  status: filters?.status?.value ?? "",
                })
              );
          }}
          onViewMore={(row) => {}}
          onActionClicked={(data) => {
            if (data) {
              changeSettlementStatus(data?.action, data?.trans?.settlementId);
            }
          }}
          emptyDataMessage="No settlements found."
        />
      </div>

      {reportModal && (
        <CustomModal
          headerTitle="Download Report"
          open={reportModal}
          onClose={() => {
            setReportModal(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          {currentTab === 0 ? (
            <DownloadSettlementModal />
          ) : currentTab === 1 ? (
            <DownloadRevenueModal />
          ) : null}
        </CustomModal>
      )}
      {uploadReport && (
        <CustomModal
          headerTitle="Upload settlement"
          open={uploadReport}
          onClose={() => {
            setUploadReport(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <div
            style={{
              minWidth: 350,
              maxWidth: 450,
              height: "240px",
              border: "1px solid #DFE3EC",
              borderRadius: "8px",
              gap: "10px",
              marginTop: "20px",
              alignItems: "center",
              textAlign: "center",
              paddingTop: "40px",
            }}
          >
            <UploadBtn
              onChange={(data) => {
                console.log(data, "uploaded file");
                setUploadFile(data);
                //onClickUploadFileInt();
              }}
              value={uploadFile}
              accept=".xlsx"
              imageTypeArray={["xlsx"]}
            />

            <p style={{ fontSize: "14px", fontWeight: 500, color: "#7181A1" }}>
              upload file
            </p>
            <p
              style={{
                color: "#4D74FF",
                fontSize: "10px",
                margin: "27% 0 0 75%",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={fileDownloadSample}
            >
              Download Sample
            </p>
          </div>
        </CustomModal>
      )}
      {openFailedModal && failedEntry.length > 0 && (
        <>
          <CustomModal
            headerTitle="Failed Entries"
            open={openFailedModal}
            onClose={() => {
              setOpenFailedModal(false);
              refreshPage();
            }}
            containerStyle={{
              minWidth: "70%",
              minHeight: "50%",
            }}
            isConfirmationModalRequired={true}
          >
            <div
              style={{
                height: "70%",
                overflow: "auto",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
              }}
            >
              <table
                style={{ width: "100%", paddingRight: "30px" }}
                className="rwd-table"
              >
                <thead className="rwd-table-body">
                  <tr style={{ position: "sticky", top: 0, zIndex: 1 }}>
                    <th>Date</th>
                    <th>Bene Name</th>
                    <th>Account Number</th>
                    <th>Cycle</th>
                    <th>Total volume</th>
                    <th>Bank transfer</th>
                    <th>Bank utr</th>
                    <th>Reason</th>
                  </tr>
                </thead>

                <tbody className="rwd-table-body">
                  {failedEntry.map((e, index) => (
                    <tr key={index}>
                      <td style={{}}>
                        {excelDateToJSDate(e["DATE"]).toISOString()}
                      </td>
                      <td style={{}}>{e.bene_name}</td>
                      <td style={{}}>{e.account_number}</td>
                      <td style={{}}>{e.cycle}</td>
                      <td style={{}}>{e["total.volume"]}</td>
                      <td style={{}}>{e.bank_transfer}</td>
                      <td style={{}}>{e.UTR}</td>
                      <td style={styles.reason} class="reason">
                        <span className="tooltip">
                          <FiInfo
                            size={30}
                            className="info-icon"
                            style={{ color: "red" }}
                          />
                          <span className="tooltiptext">{e.reason}</span>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CustomModal>
        </>
      )}
    </div>
  );
}

const styles = {
  reason: {
    color: "blue",
    fontSize: "20px",
    fontWeight: 500,
    padding: "3px",
  },
};

export default SettlementIndex;
